import About from "./components/About";
import Experiance from "./components/Experiance";
import Header from "./components/Header";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import { useRef } from "react";
import Testimonials from "./components/Testimonials";
import Hello from "./components/Hello";
import Bottom from "./components/Bottom";
import Scroll from "./components/Scroll";
import Header2 from "./components/Header2";

function App() {
  return (
    <div>
      <Scroll />
      <Header />
      {/* <Header2 /> */}
      <About />
      <Skills />
      <Experiance />
      <Projects />
      <Testimonials />
      <Hello />
      <Bottom />
    </div>
  );
}

export default App;
